import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

export interface SubscribeNewsletterDto {
  email: string;
}

@Injectable({
  providedIn: 'root',
})
export class ApiNewsletterService {
  private readonly urlPath = '/v1/newsletter';

  constructor(private readonly httpClient: HttpClient) {}

  public async subscribe(options: SubscribeNewsletterDto): Promise<void> {
    const response$ = this.httpClient.post<void>(
      environment.apiBaseUrl + this.urlPath + '/subscribe',
      options,
    );
    return lastValueFrom(response$);
  }
}
